// extracted by mini-css-extract-plugin
module.exports = {"subheader":"SubHeader_subheader__vuOqf"};